<template>
  <div class="pa16  b-fff minh100p">
    <site-message-search />
    <site-message-table />
    <site-message-modal />
    <site-message-group-drawer ref="groupDrawerRef" />
  </div>
</template>

<script>
import SiteMessageSearch from './components/Search.vue'
import SiteMessageTable from './components/Table.vue'
import SiteMessageModal from './components/EditModal.vue'
import SiteMessageGroupDrawer from './components/group/GroupDrawer.vue'
import { onMounted, provide, reactive, toRefs, ref } from 'vue'
import {
  query_message_type_list,
  query_message_type_group_list,
  query_message_type_detail,
  delete_message_type_detail
} from 'server/modules/message'
import { message } from 'ant-design-vue'

export default {
  name: 'SiteMessage',
  components: {
    SiteMessageGroupDrawer,
    SiteMessageSearch,
    SiteMessageTable,
    SiteMessageModal
  },
  setup() {
    const groupDrawerRef = ref(null)
    const state = reactive({
      total: 0,
      pageNum: 1,
      pageSize: 10,
      params: {
        groupCodes: [],
        messageTypeName: null
      },
      dataList: [],
      messageTypeGroups: [],
      drawer: {
        visible: false,
        title: null,
        groupCodeSelectDisabled: false,
        groupCode: null,
        groupName: null,
        messageTypeCode: null,
        messageTypeName: null,
        messageLevel: null
      },

      // 修改页码
      changePage: pageNum => {
        state.pageNum = pageNum
        state.getList()
      },

      setEmpty: () => {
        state.params = {
          groupCodes: [],
          messageTypeName: null
        }
        state.pageNum = 1
        state.pageSize = 10
        state.getList()
      },

      onShowSizeChange(current, pageSize) {
        state.pageNum = current
        state.pageSize = pageSize
        state.getList()
      },

      getMessageTypeGroup: async () => {
        const { success, data } = await query_message_type_group_list({
          pageNum: 1,
          pageSize: 0
        })
        if (success && data.list) {
          state.messageTypeGroups = data.list.map(item => ({
            label: item.groupName,
            value: item.groupCode
          }))
        } else {
          state.messageTypeGroups = []
        }
      },

      getList: async () => {
        const { success, retInfo, data } = await query_message_type_list({
          ...state.params,
          ...{
            pageNum: state.pageNum,
            pageSize: state.pageSize
          }
        })

        if (success) {
          const { list, total } = data
          state.dataList = list
          state.total = total
        } else {
          message.error(retInfo)
        }
      },

      showDraw: async record => {
        state.drawer.visible = true
        if (!record) {
          state.drawer.title = '新增消息类型'
          state.drawer.groupCodeSelectDisabled = false
          state.drawer.groupCode = null
          state.drawer.groupName = null
          state.drawer.messageTypeCode = null
          state.drawer.messageTypeName = null
          return
        }

        state.drawer.title = '编辑消息类型'
        state.drawer.groupCodeSelectDisabled = true
        state.drawer.groupCode = record.groupCode
        state.drawer.groupName = record.groupName
        state.drawer.messageTypeCode = record.typeCode
        state.drawer.messageTypeName = record.typeName
        state.drawer.messageLevel = record.level
      },

      onDeleted: async messageTypeCode => {
        const { success, retInfo } = await delete_message_type_detail({
          messageTypeCode: messageTypeCode
        })

        if (success) {
          state.getList()
        } else {
          message.error(retInfo)
        }
      },
      showMessageGroup: () => {
        if (groupDrawerRef.value && groupDrawerRef.value.groupState) {
          groupDrawerRef.value.groupState.showDrawer()
        }
      }
    })

    provide('state', state)

    onMounted(() => {
      state.getMessageTypeGroup()
      state.getList()
    })

    return {
      ...toRefs(state),
      groupDrawerRef
    }
  }
}
</script>

<style scoped></style>
